import { useEffect, useRef, useState } from 'react';
import { getReportsStocks } from '../../../../services/reports/stocksService';

/**
 * Fetch del informe cada vez que cambian filtros o pautado. Persiste
 * ambos estados en la URL antes de pedir. Descarta respuestas que llegan
 * fuera de orden (el usuario cambió algo mientras cargaba).
 */
export const useStocksData = (filterState, pivotConfig) => {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const requestId = useRef(0);

  const { ready, validFilters, dateParams, scopeParams, persistInUrl: persistFilters } = filterState;
  const { configParams, queryParams, persistInUrl: persistConfig } = pivotConfig;

  useEffect(() => {
    if (!ready) return;
    persistFilters();
    persistConfig();

    const id = requestId.current + 1;
    requestId.current = id;
    setLoading(true);
    setError(null);

    getReportsStocks({ ...dateParams, ...scopeParams, ...validFilters, ...queryParams })
      .then((r) => {
        if (requestId.current !== id) return;
        setReport(r.data);
      })
      .catch((e) => {
        if (requestId.current !== id) return;
        setReport(null);
        setError(e?.response?.data?.message || 'No se ha podido cargar el informe');
      })
      .finally(() => {
        if (requestId.current === id) setLoading(false);
      });
    // `persistFilters` y `persistConfig` cambian de identidad en cada render
    // pero son idempotentes; las dependencias reales son los parámetros.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, validFilters, dateParams, scopeParams, queryParams]);

  // Medidas, escala y representación no relanzan la consulta (se piden todas), pero
  // también viven en la URL: se persisten aparte.
  useEffect(() => {
    if (ready) persistConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, configParams, pivotConfig.moneyScale, pivotConfig.repr]);

  return { report, pivot: report?.pivot ?? null, loading, error };
};
